import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

interface LinkQueryToGroupParams {
    queryId: string | number;
    groupQueryName: string;
    queryName?: string;
}

export const useLinkQueryToGroup = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const linkQueryToGroup = useCallback(async ({ queryId, groupQueryName, queryName }: LinkQueryToGroupParams): Promise<boolean> => {
        if (!isReady || !queryId || !groupQueryName.trim()) return false;

        setLoading(true);
        setError(null);

        try {
            await authFetch('/defineGroupQueryForQuery', {
                method: 'POST',
                body: JSON.stringify({ queryId: queryId.toString(), groupQueryName, ...(queryName && { queryName }) }),
            });
            return true;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erreur lors de la liaison au groupe');
            return false;
        } finally {
            setLoading(false);
        }
    }, [authFetch, isReady]);

    return { linkQueryToGroup, loading, error };
};

